class SizeGuide extends HTMLElement {
  constructor() {
    super()

    this.els = {
      tab: this.querySelectorAll('[data-size-guide-el="tab"]'),
      close: this.querySelector('[data-size-guide-el="close"]'),
      table: this.querySelector('[data-size-guide-el="table"]'),
      body: this.querySelectorAll('[data-size-guide-el="body"]'),
      select: this.querySelector('[data-size-guide-el="select"]'),
      toggle: this.querySelector('[data-size-guide-el="toggle"]'),
      option: this.querySelectorAll('[data-size-guide-el="option"]'),
      toggleInput: this.querySelector('[data-size-guide-el="toggle-input"]'),
    }

    this.externalEls = {
      trigger: document.querySelector('[data-size-guide-external-el="trigger"]'),
      backdrop: document.querySelector('[data-size-guide-external-el="backdrop"]'),
    }

    this.setupListeners()
  }

  setupListeners () {
    this.externalEls.trigger.addEventListener('click', this.openDrawer.bind(this))

    this.els.select.addEventListener('change', this.handleSelect.bind(this))

    this.els.toggleInput.addEventListener('click', this.handleToggle.bind(this))

    this.els.tab.forEach(tab => {
      tab.addEventListener('click', this.handleTab.bind(this))
    })
  }

  openDrawer (e) {
    e.preventDefault()

    document.body.classList.add('open-cc')
    document.body.classList.add('open-size-guide')

    this.classList.add('active')
    this.externalEls.backdrop.classList.add('active')

    this.els.close.focus()

    dispatchCustomEvent('size-guide-drawer:open')
  }

  handleToggle () {
    if (!this.els.table || !this.els.select) return

    const currentSelectedOption = this.els.select.value
    const unit = this.els.toggleInput?.checked ? 'in' : 'cm'
    const tableDataEls = this.els.table.querySelectorAll('td')

    this.els.toggle.setAttribute('data-unit', unit)

    tableDataEls.forEach(td => {
      const parentTr = td.closest('tr')
      const value = td.getAttribute(`data-${currentSelectedOption}-${unit}`)
      const shouldConvert = parentTr && parentTr.dataset.convertMeasurement === 'true'

      if (value !== null && shouldConvert) {
        td.textContent = value
      }
    })
  }

  handleSelect () {
    if (!this.els.table || !this.els.select) return

    const selectValue = this.els.select.value
    const unit = this.els.toggleInput.checked ? 'in' : 'cm'
    const tableDataEls = this.els.table.querySelectorAll('td')

    tableDataEls.forEach(td => {
      const parentTr = td.closest('tr')
      const value = td.getAttribute(`data-${selectValue}-${unit}`)
      const shouldConvert = parentTr && parentTr.dataset.convertOption === 'true' && parentTr.dataset.convertMeasurement === 'true'

      if (value !== null && shouldConvert) {
        td.textContent = value
      } else {
        const defaultValue = td.getAttribute(`data-${selectValue}-cm`)

        if (defaultValue !== null) {
          td.textContent = defaultValue
        }
      }
    })
  }

  handleTab (e) {
    this.els.tab.forEach(tab => {
      tab.setAttribute('aria-selected', 'false')
    })

    e.currentTarget.setAttribute('aria-selected', 'true')

    this.els.body.forEach(body => {
      body.setAttribute('aria-visible', 'false')

      const content = body.dataset.content
      const targetContent = e.currentTarget.dataset.target
      
      if (content === targetContent) {
        body.setAttribute('aria-visible', 'true')
      }
    })

    



    // const tabContentId = e.currentTarget.getAttribute('aria-controls')
    // const tabContent = this.querySelector(`#${tabContentId}`)

    // if (tabContent) {
    //   const allTabContents = this.querySelectorAll('[data-size-guide-el="tab-content"]')

    //   allTabContents.forEach(content => {
    //     content.hidden = true
    //   })

    //   tabContent.hidden = false
    // }
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
